export var MismatchStatus;
(function (MismatchStatus) {
    MismatchStatus["Pending"] = "PENDING";
    MismatchStatus["ResolvedAcceptPdf"] = "RESOLVED_ACCEPT_PDF";
    MismatchStatus["ResolvedKeepMine"] = "RESOLVED_KEEP_MINE";
    MismatchStatus["ResolvedEditManual"] = "RESOLVED_EDIT_MANUAL";
    MismatchStatus["ResolvedKeepBoth"] = "RESOLVED_KEEP_BOTH";
})(MismatchStatus || (MismatchStatus = {}));
//# sourceMappingURL=mismatch-status.enum.js.map